<template>
   <div class="tabWarp">
    <div class="topBox">
      <div class="btn-box">
        <button :class="{'activeBtn':activeBtn==='project'}" @click="setType('project')">项目统计</button>
        <button :class="{'activeBtn':activeBtn==='date'}" @click="setType('date')">日统计</button>
      </div>
      <div class="rightBox">
        <DomainInput @setDomain="setDomain"></DomainInput>
        <div v-show="activeBtn==='date'" class="dateBox">
          <span class="lab">日期：</span>
          <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="dateChange">
          </el-date-picker>
        </div>
      </div>
    </div>
    <el-table v-loading="loading" :header-cell-style="{background:'#EEF5FF',color:'#566087'}" ref="projectTable"
      tooltip-effect="dark" style="width:100%" :data="data">
      <template slot="empty">
        <div id="notDate">
          <img src="../../../assets/imgs/memory/no_data.png" alt />
          <p>暂无数据</p>
        </div>
      </template>
      <el-table-column align="center" label="项目名称" :show-overflow-tooltip="true" prop="projectName"></el-table-column>
      <el-table-column align="center" label="翻译速度（字/分钟）" :show-overflow-tooltip="true" prop="langDesc">
        <template slot-scope="scope">
          <div>
            {{ scope.row.transCostTime ? Math.round((scope.row.transWordNum/(scope.row.transCostTime/60))) : scope.row.transCostTime}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="翻译字数" :show-overflow-tooltip="true" prop="transWordNum"></el-table-column>
      <el-table-column align="center" label="语言对" :show-overflow-tooltip="true" prop="langDesc"></el-table-column>
      <el-table-column align="center" label="领域" :show-overflow-tooltip="true" prop="domainName" min-width="123">
      </el-table-column>
      <el-table-column align="center" label="日   期" :show-overflow-tooltip="true"
        :prop="activeBtn==='project' ? 'createTime' : 'transDate'" min-width="123">
      </el-table-column>
    </el-table>

    <div class="paging_device">
      <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
        :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
        @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>

</template>

<script>
import DomainInput from "@/common/Statistics/InterpreterStatistics/DomainInput";
import tabMixin from "./tabMixin";
export default {
  props: {

  },
  mixins: [tabMixin],
  data() {
    return {
      loading: false,
      data: [],
      activeBtn: "project",
      date: "",
      url:"/api/v1/taskCost/queryPageByProject"
    };
  },
  components: {
    DomainInput,

  },
  created() {
    this.getPage()
  },
  mounted() {

  },
  methods: {
    dateChange(date) {
      this.currentPage = 1;
      this.getPage()
    },
    setType(type) {
      this.url = "/api/v1/taskCost/queryPageByProject"
      if (type === 'date') {
        this.url = '/api/v1/taskCost/queryPageByDate';
        this.activeBtn = type
      } else {
        this.activeBtn = "project"
        this.date = null
      }
      this.getPage()
    },
    async getPage() {
      
      let params = {
        filter: {
          companyCode: localStorage.myCompanyCode,
          userId: this.$route.query.id,
          transDateStart: this.date ? this.date[0] : undefined,
          transDateEnd: this.date ? this.date[1] : undefined,
          domainCode: this.domainCode
        },
        page: this.currentPage,
        rows: this.rows
      };
      const { resultCode, list, totalRows } = await this.catReq1Service(this.url, params)
      if (resultCode === '1') {
        list.forEach(item=>{
            if (item.createTime) {
              item.createTime = this.dateReg(item.createTime);
            }
            if (item.transDate) {
              item.transDate = this.dateReg(item.transDate);
            }
        })
        this.data = list;
        this.totalRows = totalRows
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./common.less";
.topBox {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 14px;
  .rightBox {
    display: flex;
    .dateBox {
      .lab {
        font-weight: bold;
        color: #566087;
        margin-left: 38px;
      }
    }
    .el-input__inner {
      background-color: #F9F9F9;
      color: #343434;
    }
    /deep/ .el-range-input{
      background-color: #F9F9F9;
    }
  }
}
.btn-box {
  button {
    width: 80px;
    height: 36px;
    line-height: 36px;
    background: #ffffff;
    color: #4095ff;
    border: 1px solid #4095ff;
    border-radius: 6px;
    margin-right: 28px;
    box-sizing: border-box;
  }
  .activeBtn {
    background: #4095ff;
    color: #ffffff;
    border: 1px solid #fff;
  }
}
</style>
